import { useCallback, useState } from "react";
import { fetchHandlers } from "./api";
import type { Handler } from "./types";

interface UseHandlersResult {
  handlers: Handler[];
  loading: boolean;
  ensureLoaded: () => Promise<void>;
}

export const useHandlers = (
  onError?: (message: string) => void,
): UseHandlersResult => {
  const [handlers, setHandlers] = useState<Handler[]>([]);
  const [loading, setLoading] = useState(false);

  const ensureLoaded = useCallback(async () => {
    if (handlers.length > 0) return;
    try {
      setLoading(true);
      const data = await fetchHandlers();
      setHandlers(data);
    } catch (err) {
      console.error("Error fetching handlers:", err);
      onError?.("Failed to load handlers. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [handlers.length, onError]);

  return { handlers, loading, ensureLoaded };
};
